module.exports = __webpack_public_path__ + "components/MapControl/svg/Ośrodek wczasowy_pensjonat.svg?cc5d80f7";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Ośrodek wczasowy_pensjonat.svg
// module id = 2008
// module chunks = 0